import axios, { AxiosError } from "axios";
import { getActiveLang } from "../i18n";

const baseURL =
  process.env.REACT_APP_API_BASE_URL ?? "http://localhost:8000";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export const api = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  config.headers["Accept-Language"] = getActiveLang();
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError) => {
    const status = err.response?.status ?? 0;
    const data = err.response?.data as any;
    const message =
      (typeof data?.detail === "string" && data.detail) || err.message;
    // status === 0 covers both true network failures and cancelled requests;
    // we don't cancel requests anywhere yet, so the conflation is fine.
    const code = status === 0 ? "network" : `http_${status}`;
    return Promise.reject(new ApiError(status, code, message, err.response?.data));
  },
);
